import { InputField, LabelComponent } from 'components';
import { ErrorContainer } from 'components';
import { useFormikContext } from 'formik';

export const DocumentationTime = ({ disabled }: { disabled: boolean }) => {
  const formik = useFormikContext<{
    documentationTime: number | null;
  }>();

  return (
    <>
      <LabelComponent mandatory text="Documentation Time (min)" />
      <InputField
        withGradient
        value={formik.values.documentationTime?.toString() ?? ''}
        onBlur={formik.handleBlur}
        onChange={(e) => {
          // only allow numbers
          if (e.target.value.match(/^[0-9]*$/)) {
            formik.handleChange(e);
          }
        }}
        name="documentationTime"
        placeholder="0"
        disabled={disabled}
      />
      <ErrorContainer
        visible={formik.touched?.documentationTime && formik.errors?.documentationTime}
        errors={formik.errors}
        name="documentationTime"
      />
    </>
  );
};
